module.exports = __webpack_public_path__ + "static/media/mail.77187791.svg";